import { DisablePersonalSyncDocument } from "#webapp/src/components/event-card/__generated__/DisablePersonalSync.v2.generated";
import { track, TrackingEvents } from "#webapp/src/util/analytics.util";
import { Button } from "@clockwise/design-system";
import { Delete } from "@clockwise/icons";
import { useGatewayMutation } from "@clockwise/web-commons/src/network/apollo/gateway-provider";
import React from "react";
import toast from "react-hot-toast";

export const UnsyncButton = ({ eventId, onRemove }: { eventId: string; onRemove?: () => void }) => {
  const [removeSync] = useGatewayMutation(DisablePersonalSyncDocument, {
    onCompleted: (data) => {
      if (data.disablePersonalSync?.success) {
        toast.success("This event will no longer be synced from your personal calendar");
        onRemove?.();
      } else {
        toast.error("Sorry, there was a problem removing your synced event");
      }
    },
    onError: () => toast.error("Sorry, there was a problem removing your synced event"),
  });

  const handleSyncRemoved = () => {
    void removeSync({
      variables: {
        externalEventId: eventId,
      },
      refetchQueries: ["CalendarEventsQuery"],
    });
    track(TrackingEvents.EVENT.REMOVE_SYNCED_PERSONAL_CALENDAR_EVENT);
  };

  return (
    <Button
      variant="text"
      size="mini"
      startIcon={Delete}
      disabled={false}
      onClick={handleSyncRemoved}
    />
  );
};
